module.exports = __webpack_public_path__ + "img/pic4.b55035af.png";